import { SiteFooterConfig } from '../app/core/site-config.model';

const SHARED_SUPPORT_HOURS = {
  scheduleLines: [
    'Lunes a Jueves: Península y Baleares - 8:00h a 17:00h. Canarias - 7:00h a 16:00h',
    'Viernes: Península y Baleares - 8:00h a 13:30h. Canarias - 7:00h a 12:30h',
  ],
};

const SHARED_APP_DOWNLOAD = {
  enabled: true,
  ios: {
    storeUrl: 'https://apps.apple.com/es/app/oficina-virtual-ggm/id1515678663',
    qrImageUrl: 'assets/img/qr-ov-ios.png',
    buttonImageUrl: 'assets/img/badge-app-store.png',
    buttonLabel: 'App Store',
  },
  android: {
    storeUrl:
      'https://play.google.com/store/apps/details?id=com.gomezgroupmetering.appoficinavirtual2020',
    qrImageUrl: 'assets/img/qr-ov-android.png',
    buttonImageUrl: 'assets/img/badge-google-play.png',
    buttonLabel: 'Google Play',
  },
};

export const GOMEZ_FOOTER_DEFAULTS: SiteFooterConfig = {
  copyrightText: 'Gomez Group Metering. Todos los derechos reservados.',
  legalNoticeUrl: 'https://www.gomezgroupmetering.com/pdf/footer/avisoLegal.pdf',
  privacyPolicyUrl: 'https://www.gomezgroupmetering.com/pdf/footer/politica_privacidad.PDF',
  customerSupportPhone: '+34913030000',
  customerSupportPhoneDisplay: '91 303 00 00',
  customerSupportEmail: 'info@gomezgroupmetering.com',
  customerSupportHours: SHARED_SUPPORT_HOURS,
  socialLinks: [
    {
      label: 'Facebook',
      url: 'https://www.facebook.com/gomezgroupmetering/',
      icon: 'pi pi-facebook',
    },
    {
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/company/gomez-group-metering',
      icon: 'pi pi-linkedin',
    },
    {
      label: 'YouTube',
      url: 'https://www.youtube.com/channel/UCgeQIvg5w-rLUyJdJskEyQA',
      icon: 'pi pi-youtube',
    },
  ],
  tenantAppDownload: {
    ...SHARED_APP_DOWNLOAD,
    title: 'Descarga la app Oficina Virtual Abonados',
  },
};

export const ARANCONTA_FOOTER_DEFAULTS: SiteFooterConfig = {
  ...GOMEZ_FOOTER_DEFAULTS,
  copyrightText: 'Aranconta Metering. Gomez Group Metering. Todos los derechos reservados.',
  privacyPolicyUrl: 'https://www.gomezgroupmetering.com/pdf/footer/politica_privacidadAranconta.PDF',
  tenantAppDownload: {
    ...SHARED_APP_DOWNLOAD,
    title: 'Descarga la app Oficina Virtual Aranconta',
  },
};
